<script setup lang="ts">
    import { Button } from '@/components/ui/button';
    import { RotateCcwKey } from 'lucide-vue-next';
</script>

<template>
    <Button
        variant="edit"
        size="xs"
    >
        <span>{{ $t('users.js.reset.title') }}</span>
        <RotateCcwKey />
    </Button>
</template>
